import React , {Component} from 'react';
import './index.css'
import homeClicked from '../../assets/icons/homeclick.png'
import homeUnClicked from '../../assets/icons/homeunclick.png'
import importClicked from '../../assets/icons/importclicked.png'
import importUnClicked from '../../assets/icons/importunclicked.png'
import omgClicked from '../../assets/icons/omgclicked.png'
import omgUnClicked from '../../assets/icons/omgunclicked.png'
import saleClicked from '../../assets/icons/saleclicked.png'
import saleUnClicked from '../../assets/icons/saleunclicked.png'
import userClicked from '../../assets/icons/userclicked.png'
import userUnClicked from '../../assets/icons/userunclicked.png'
import {NavLink} from 'react-router-dom'

export default class Bottom extends Component{
  constructor(props) {
    super(props);
    this.state = {
      home: true,
      omg: false,
      sale: false,
      user: false,
      import: false,
     }
} 
toggleHome = () => {
  this.setState({home: true,omg: false,sale: false, user: false, import: false})
};
toggleImport = () => {
  this.setState({home: false,omg: false,sale: false, user: false, import: true})
};
toggleOmg = () => {
  this.setState({home: false,omg: true,sale: false, user: false, import: false})
};
toggleSale = () => {
  this.setState({home: false,omg: false,sale: true, user: false, import: false})
};
toggleUser = () => {
  this.setState({home: false,omg: false,sale: false, user: true, import: false})
};
render(){return(
    <div className="parent-bottom">
      <div className="bHome">
      <NavLink to="/home" onClick={this.toggleHome} style={{display: `${this.state.home ? "": 'none'}`}}>
        <img alt="Arrow" src={homeClicked} />
      </NavLink>
         <NavLink to="/home" onClick={this.toggleHome} style={{display: `${this.state.home ? "none": ''}`}}>
           <img alt="Arrow" src={homeUnClicked}/>
          </NavLink>
      </div>
      <div className="bImport">
      <NavLink to="/search" onClick={this.toggleImport} style={{display: `${this.state.import ? "": 'none'}`}}>
        <img alt="Arrow" src={importClicked} />
      </NavLink>
         <NavLink to="/search" onClick={this.toggleImport} style={{display: `${this.state.import ? "none": ''}`}}>
           <img alt="Arrow" src={importUnClicked}  />
          </NavLink>
      </div>
      <div className="bOmg">
      <NavLink to="/popular" onClick={this.toggleOmg} style={{display: `${this.state.omg ? "": 'none'}`}}>
        <img alt="Arrow" src={omgClicked}/>
      </NavLink>
         <NavLink to="/popular" onClick={this.toggleOmg} style={{display: `${this.state.omg ? "none": ''}`}}>
           <img alt="Arrow" src={omgUnClicked}/>
          </NavLink>
      </div>
      <div className="bSale">
      <NavLink to="/sale" onClick={this.toggleSale} style={{display: `${this.state.sale ? "": 'none'}`}}>
        <img alt="Arrow" src={saleClicked} />
      </NavLink>
         <NavLink to="/sale" onClick={this.toggleSale} style={{display: `${this.state.sale ? "none": ''}`}}>
           <img alt="Arrow" src={saleUnClicked}  />
          </NavLink>
      </div>
      <div className="bUser">
      <NavLink to="/user" onClick={this.toggleUser} style={{display: `${this.state.user ? "": 'none'}`}}>
        <img alt="Arrow" src={userClicked} />
      </NavLink>
         <NavLink to="/user" onClick={this.toggleUser} style={{display: `${this.state.user ? "none": ''}`}}>
           <img alt="Arrow" src={userUnClicked}  />
          </NavLink>
      </div>
    </div>
)}
}